import { Typography, useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { DEFAULT_BORDER } from 'src/constants';
import { InvoiceHistoryLog } from 'src/utils/tableUtils';

interface InvoiceHistoryTableProps {
    historyLogs: InvoiceHistoryLog[];
}

const InvoiceHistoryTable = ({ historyLogs }: InvoiceHistoryTableProps) => {
    const theme = useTheme();

    return (
        <TableContainer component={Paper}>
            <Table
                sx={{
                    ...DEFAULT_BORDER,
                    minWidth: 650,
                }}
                aria-label="invoice history table"
            >
                <TableHead>
                    <TableRow sx={{ bgcolor: theme.palette.common.orange }}>
                        {(() => {
                            const headers = ['Date/Time', 'Description', 'User'];
                            return headers.map((header) => {
                                return (
                                    <th key={header}>
                                        <Typography
                                            textAlign="start"
                                            p="16px"
                                            color={theme.palette.text.primary}
                                        >
                                            {header}
                                        </Typography>
                                    </th>
                                );
                            });
                        })()}
                    </TableRow>
                </TableHead>
                <TableBody data-testid="invoice-history-body">
                    {historyLogs.map((row, index) => {
                        return (
                            <TableRow
                                key={`${index}-${row.user}`}
                                sx={{
                                    bgcolor:
                                        index % 2 !== 0
                                            ? theme.palette.common.orange
                                            : theme.palette.background.default,
                                }}
                            >
                                {(() => {
                                    const rowData = [row.invoiceDate, row.description, row.user];
                                    return rowData.map((row, index) => {
                                        return (
                                            <td key={index}>
                                                <Typography
                                                    textAlign="start"
                                                    p="16px"
                                                    color={theme.palette.text.primary}
                                                >
                                                    {row}
                                                </Typography>
                                            </td>
                                        );
                                    });
                                })()}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
export default InvoiceHistoryTable;
